import React from 'react';
import "../Assets/Css/HomeCss/ContactUsBanner.css";

const ContactUsBanner = () => {
  return (
    <div className="contact-banner">
      <div className="contact-banner-content">
        <h1>Contact Us</h1>
        <p>Use the form to submit your queries or email us</p>
      </div>
    </div>
  );
};

export default ContactUsBanner;
